import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const selectedJaneStaffTypeFilterSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.selectedJaneStaffTypeFilter,
);

export default selectedJaneStaffTypeFilterSelector;
